import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { OrderHistoryEvent } from '../../models-otc/order-history-event.model';
import { OrderHistoryService } from '../../services-otc/order-history.service';

@Component({
    selector: 'app-order-history',
    templateUrl: './order-history.component.html',
    styleUrls: ['./order-history.component.css'],
    standalone: false
})
export class OrderHistoryComponent implements OnChanges {
    @Input() orderId: number;

    events: OrderHistoryEvent[] = [];
    isLoading = false;
    hasError = false;
    expandedIndex = -1;

    constructor(private orderHistoryService: OrderHistoryService) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['orderId'] && this.orderId) {
            this.loadHistory();
        }
    }

    loadHistory(): void {
        this.isLoading = true;
        this.hasError = false;
        this.orderHistoryService.getOrderHistory(this.orderId).subscribe({
            next: (events) => {
                this.events = events;
                this.isLoading = false;
            },
            error: () => {
                this.hasError = true;
                this.isLoading = false;
            }
        });
    }
}
